import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ClinicalTrainingEventsState } from './types';
import { ListStatus, EditableStatus } from '@/store/types';

export const getters: GetterTree<ClinicalTrainingEventsState, RootState> = {
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsEmpty: (state) => state.list.length === 0,
  listHasError: (state) => state.listStatus === ListStatus.Failed,

  editableIsLoading: (state) => state.editableStatus === EditableStatus.Loading,
  editableIsLoaded: (state) => state.editableStatus === EditableStatus.Loaded,
  editableIsSaving: (state) => state.editableStatus === EditableStatus.Saving,
  editableIsSaved: (state) => state.editableStatus === EditableStatus.Saved,
  editableHasError: (state) => state.editableStatus === EditableStatus.Failed,
  editableHasUnsavedChanges: (state) => {
    if (!state.editable || !state.initialEditable) {
      return false;
    }

    return JSON.stringify(state.editable.toJSON()) !== JSON.stringify(state.initialEditable.toJSON());
  },
};
